import { render, staticRenderFns } from "./noPlan.vue?vue&type=template&id=93d28390&"
import script from "./noPlan.vue?vue&type=script&lang=js&"
export * from "./noPlan.vue?vue&type=script&lang=js&"
import style0 from "./noPlan.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports